import React from 'react';
import { Trash2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
interface AdminServicesManagerProps {
  services: any[];
  setCreatePanel: (panel: any) => void;
  handleDeleteService: (id: number) => void;
  renderTableHeader: (title: string, count: number, onExport?: () => void, onCreate?: () => void, createLabel?: string) => React.ReactNode;
  generateCSV: (data: any[], name: string) => void;
}
export function AdminServicesManager({
  services,
  setCreatePanel,
  handleDeleteService,
  renderTableHeader,
  generateCSV
}: AdminServicesManagerProps) {
  return <div className="space-y-4" data-id="element-6083">
      {renderTableHeader('Услуги', services.length, () => generateCSV(services, 'services'), () => setCreatePanel({
      type: 'service',
      title: 'Добавить услугу'
    }), 'Добавить')}
      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-6084">
        <table className="w-full text-left" data-id="element-6085">
          <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-6086">
            <tr data-id="element-6087">
              <th className="px-3 py-2" data-id="element-6088">Название</th>
              <th className="px-3 py-2" data-id="element-6089">Тип</th>
              <th className="px-3 py-2" data-id="element-6090">Цена</th>
              <th className="px-3 py-2" data-id="element-6091">Статус</th>
              <th className="px-3 py-2" data-id="element-6092"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-6093">
            {services.map(s => <tr key={s.id} className="hover:bg-slate-50" data-id="element-6094">
                <td className="px-3 py-2 text-sm font-medium" data-id="element-6095">{s.title}</td>
                <td className="px-3 py-2 text-xs text-slate-500" data-id="element-6096">{s.type}</td>
                <td className="px-3 py-2 text-sm font-bold" data-id="element-6097">{s.price}</td>
                <td className="px-3 py-2" data-id="element-6098">
                  <Badge variant={s.active ? 'success' : 'neutral'} size="sm" data-id="element-6099">
                    {s.active ? 'Активна' : 'Выкл'}
                  </Badge>
                </td>
                <td className="px-3 py-2 text-right" data-id="element-6100">
                  <Button variant="ghost" size="sm" className="text-rose-500" icon={<Trash2 className="w-3 h-3" data-id="element-6102" />} onClick={() => handleDeleteService(s.id)} data-id="element-6101" />
                </td>
              </tr>)}
          </tbody>
        </table>
      </Card>
    </div>;
}